import React from "react";
import {
  getVeLotteryDisplay,
  VELOTTERY_ICON_SRC,
  VELOTTERY_ICON_CLASS,
} from "../utils/veLotteryDisplay.js";

export default function VeLotteryTypeLabel({
  classification,
  leading = null,
  className = "",
}) {
  const display = getVeLotteryDisplay(classification);
  if (!display) return null;

  return (
    <span
      className={`inline-flex min-w-0 items-start gap-2 text-left font-semibold text-blue-600 ${className}`}
    >
      {leading ? (
        <span className="mt-0.5 flex-shrink-0" aria-hidden="true">
          {leading}
        </span>
      ) : null}
      <img
        src={VELOTTERY_ICON_SRC}
        alt="VeLottery"
        className={VELOTTERY_ICON_CLASS}
        loading="lazy"
        decoding="async"
        draggable={false}
        onError={(event) => {
          event.currentTarget.style.display = "none";
        }}
      />
      <span className="min-w-0 leading-tight">
        <span className="block whitespace-normal break-words">
          {display.title}
        </span>
        <span className="block whitespace-normal break-words text-[11px] font-medium text-blue-700/90">
          {display.subtitle}
        </span>
      </span>
    </span>
  );
}
